/**
 * Configuration Module
 *
 * This module provides configuration constants and DOM elements used throughout the theme.
 * It centralizes key values and element references to maintain consistency and ease of maintenance.
 *
 * Constants:
 * - mobileBreakpoint: The width in pixels used to determine mobile versus desktop viewports.
 *   Type: number
 *
 * Elements:
 * - elonPresReportContent: The DOM element with the ID 'elonPresReportContent'. This element is used in 
 *   various scripts to determine if the current page is the report homepage or default template.
 *   Type: HTML Element or null
 *
 * Usage:
 * import { mobileBreakpoint, elonHomeContent } from '../modules/config.js';
 */

const mobileBreakpoint = 640;
const elonPresReportContent = document.getElementById('elonPresReportContent');

export { mobileBreakpoint, elonPresReportContent };